<template>
  <div class="qrcode-container" :style="style"></div>
</template>

<script>
import QRCode from 'qrcode'
export default {
  name: 'QrcodeContainer',
  props: {
    text: {
      type: String,
      required: true
    },
    width: {
      type: Number,
      default: 128
    },
    height: {
      type: Number,
      default: 128
    }
  },
  data () {
    return {
      qrcode: null
    }
  },
  computed: {
    style () {
      return {
        width: this.width + 'px',
        height: this.height + 'px'
      }
    }
  },
  watch: {
    text: {
      handler (val) {
        if (val) {
          this.generateQrcode()
        }
      },
      immediate: true
    }
  },
  methods: {
    generateQrcode () {
      const container = this.$el
      if (container && this.text) {
        this.$nextTick(() => {
          // 清空容器
          container.innerHTML = ''
          // 生成二维码
          QRCode.toCanvas(this.text, {
            width: this.width,
            margin: 0,
            color: {
              dark: '#000000',
              light: '#ffffff'
            }
          }, (err, canvas) => {
            if (err) {
              console.error('生成二维码失败:', err)
              return
            }
            // 创建图片元素
            const img = document.createElement('img')
            img.src = canvas.toDataURL('image/png')
            container.appendChild(img)
          })
        })
      }
    }
  }
}
</script>

<style lang="scss">
.qrcode-container {
  display: inline-block;
  position: relative;
  background-color: #fff;
  overflow: hidden;
  img {
    display: block;
    width: 100%;
    height: 100%;
  }
}
</style>
